import { Text } from '@radix-ui/themes';
import { HubertButton } from 'components/HubertUI/HubertButton';
import { CircleOff, Ruler, TriangleAlert, Weight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ESliderEvaluationType } from 'types/evaluation.types';

interface Props {
  evaluationType: ESliderEvaluationType | '';
}

const SliderEvaluationTriggerButton = ({ evaluationType }: Props) => {
  const { t } = useTranslation('Templates');

  if (evaluationType === '') {
    return (
      <HubertButton size="sm" variant={'outline'} icon={<CircleOff />}>
        <Text>{t('evaluationPopover.triggerButton.notSet')}</Text>
      </HubertButton>
    );
  } else if (evaluationType === ESliderEvaluationType.Weighted) {
    return (
      <HubertButton size="sm" variant={'outline'} icon={<Weight />}>
        <Text>{t('evaluationPopover.triggerButton.weighted')}</Text>
      </HubertButton>
    );
  } else if (evaluationType === ESliderEvaluationType.Conditional) {
    return (
      <HubertButton size="sm" variant={'outline'} icon={<Ruler />}>
        <Text>{t('evaluationPopover.triggerButton.conditionalRules')}</Text>
      </HubertButton>
    );
  } else {
    return (
      <HubertButton size="sm" variant={'destructive'} icon={<TriangleAlert />}>
        <Text>{t('evaluationPopover.triggerButton.error')}</Text>
      </HubertButton>
    );
  }
};

export default SliderEvaluationTriggerButton;
